<template>
    <div>
        <h1>
            {{ title }}
        </h1>

        <mini-calc-icons></mini-calc-icons>

        <svg viewBox="0 0 120 120" class="m-mini-calc-icon">
            <use :xlink:href="'#' + icon"></use>
        </svg>
        
        <div class="u-clear"></div><br />

        <h2>
            Summary
        </h2>
    </div>
</template>

<script>
    import Icons from 'pages/mini-calculators/components/Icons';

    export default {
        name: 'mini-calculator-header',
        components: {
            'mini-calc-icons' : Icons,
        },
        props: {
            title: {
                type: String,
                default: "",
            },
            icon: {
                type: String,
                default: "",
            },
        },
    }
</script>


// WEBPACK FOOTER //
// MiniCalculatorHeader.vue?4b3cf45e